import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const getSettings = () => api.get("/settings").then((r) => r.data);
export const getList = (coll) => api.get(`/content/${coll}`).then((r) => r.data);
export const getItem = (coll, id) => api.get(`/content/${coll}/${id}`).then((r) => r.data);
export const createItem = (coll, data) => api.post(`/content/${coll}`, data).then((r) => r.data);
export const updateItem = (coll, id, data) => api.put(`/content/${coll}/${id}`, data).then((r) => r.data);
export const deleteItem = (coll, id) => api.delete(`/content/${coll}/${id}`).then((r) => r.data);
export const saveSettings = (data) => api.put("/settings", data).then((r) => r.data);

export const createRequest = (data) => api.post("/requests", data).then((r) => r.data);
export const getRequests = () => api.get("/requests").then((r) => r.data);
export const updateRequest = (id, data) => api.put(`/requests/${id}`, data).then((r) => r.data);
export const deleteRequest = (id) => api.delete(`/requests/${id}`).then((r) => r.data);
export const getAnalytics = () => api.get("/analytics/summary").then((r) => r.data);

// Seuls les trois appels publics rendez-vous utilisent l'adresse OVH.
const bookingApi = axios.create({
  baseURL: `${(process.env.REACT_APP_BOOKING_URL || BACKEND_URL).replace(/\/$/, "")}/api`,
  withCredentials: false,
  timeout: 20000,
});
export const getBookingConfig = () => bookingApi.get("/booking/config").then((r) => r.data);
export const getAvailability = (date) => bookingApi.get(`/booking/availability`, { params: { date } }).then((r) => r.data);
export const requestBooking = (data) => bookingApi.post("/booking/request", data).then((r) => r.data);
export const getAppointments = () => api.get("/booking/appointments").then((r) => r.data);
export const createAppointment = (data) => api.post("/booking/appointments", data).then((r) => r.data);
export const updateAppointment = (id, data) => api.put(`/booking/appointments/${id}`, data).then((r) => r.data);
export const deleteAppointment = (id) => api.delete(`/booking/appointments/${id}`).then((r) => r.data);
export const getBookingSettings = () => api.get("/booking/settings").then((r) => r.data);
export const saveBookingSettings = (data) => api.put("/booking/settings", data).then((r) => r.data);
export const getBookingStats = () => api.get("/booking/stats").then((r) => r.data);
